import StepsUserFormBase from './StepsUserFormBase'
import React from "react"
import StepsUserForm from './../../Components/Users/StepsUserForm'
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"

class StepsUser extends React.Component {

    render() {
                return(
                    <StepsUserFormBase title='Completa tus datos'>
                        <StepsUserForm
                            initialStep={this.props.match.params.id}
                            goBackToPayment={this.props.history.location.state == null || this.props.history.location.state.goBackToPayment}
                        >

                        </StepsUserForm>
                    </StepsUserFormBase>
                )


    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StepsUser));
